import React, { useEffect, useState } from 'react';
import { XIcon } from 'lucide-react';
interface WaitlistModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export const WaitlistModal: React.FC<WaitlistModalProps> = ({
  isOpen,
  onClose
}) => {
  const [isAnimating, setIsAnimating] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);
  useEffect(() => {
    if (isOpen) {
      setShouldRender(true);
      // Small delay to ensure DOM is ready before animation
      setTimeout(() => setIsAnimating(true), 10);
      document.body.style.overflow = 'hidden';
    } else {
      setIsAnimating(false);
      // Wait for animation to complete before unmounting
      const timer = setTimeout(() => setShouldRender(false), 300);
      document.body.style.overflow = 'unset';
      return () => clearTimeout(timer);
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);
  if (!shouldRender) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={onClose} data-id="element-324">
      {/* Backdrop with fade animation */}
      <div className={`absolute inset-0 bg-ink-text/40 backdrop-blur-sm transition-opacity duration-300 ease-out ${isAnimating ? 'opacity-100' : 'opacity-0'}`} data-id="element-325" />

      {/* Modal with scale animation */}
      <div className={`relative bg-white rounded-2xl shadow-card-hover max-w-3xl w-full max-h-[90vh] overflow-hidden transition-all duration-300 ease-out ${isAnimating ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`} onClick={e => e.stopPropagation()} data-id="element-326">
        {/* Close button */}
        <button onClick={onClose} className="absolute top-4 right-4 z-10 w-10 h-10 rounded-full bg-cloud hover:bg-sandstone flex items-center justify-center transition-colors duration-200" aria-label="Close modal" data-id="element-327">
          <XIcon className="text-deep-juniper" size={20} data-id="element-328" />
        </button>

        {/* Modal content */}
        <div className="overflow-y-auto max-h-[90vh]" data-id="element-329">
          <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSc9_VdBiAMhfaNIf6IBXW8KsGsLBQBFIe1TctaA_avWiBMtGQ/viewform?embedded=true" width="100%" height="2327" frameBorder="0" marginHeight={0} marginWidth={0} title="Re:Joy Waitlist Form" data-id="element-330">
            Loading…
          </iframe>
        </div>
      </div>
    </div>;
};